$( document ).on("turbo:load", function(){

    if ($('.custom-field-form').length > 0) {
        var type = $('#custom_field_select_options').parent();

        if ($('#custom_field_field_type').val() != 'select') {
            type.hide()
        }

        $('#custom_field_field_type').on('change', function() {
            if (this.value == 'select') {
                type.show()
            }
            else {
                document.getElementById('custom_field_select_options').value = '';
                type.hide()
            }
        });
    }

});
